import { FileMimeTypes, FilePicker } from '@/modules/common';
import { FileObject } from '@/modules/common/types';

import {
  maxBackgroundImageSize,
  maxVideoPreviewSize,
} from '../../../constants';

type VideoTabProps = {
  videoFileObject?: FileObject | null;
  idleStateVideoFileObject?: FileObject | null;
  backgroundImageFileObject?: FileObject | null;
};

export const VideoTab = ({
  videoFileObject,
  idleStateVideoFileObject,
  backgroundImageFileObject,
}: VideoTabProps) => {
  return (
    <div className="flex flex-col gap-5">
      <div className="border rounded-lg border-zinc-800 p-6">
        <h3 className="text-lg font-semibold mb-4">Event Video</h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 grid-flow-col grid-rows-6 sm:grid-rows-1 gap-6">
          <FilePicker
            label="Idle State Video (displayed when the app first opens)"
            name="idleStateVideoPublicUrl"
            accept={[FileMimeTypes.Mp4]} // only iOS-safe MP4 allowed
            useVideoIcon
            placeholder="Add video file"
            tips={
              <p className="text-sm text-zinc-500">
                <span className="text-zinc-100">mp4</span> format. 100MB max
              </p>
            }
            maxFileSize={maxVideoPreviewSize}
            initialFileName={idleStateVideoFileObject?.filename}
            initialFileSize={idleStateVideoFileObject?.contentLength}
          />

          <FilePicker
            label="Event Loading Video"
            name="publicUrl"
            useVideoIcon
            accept={[FileMimeTypes.Mp4]} // only iOS-safe MP4 allowed
            placeholder="Add video file"
            tips={
              <p className="text-sm text-zinc-500">
                <span className="text-zinc-100">mp4</span> format. 100MB max
              </p>
            }
            maxFileSize={maxVideoPreviewSize}
            requiredMark
            initialFileName={videoFileObject?.filename}
            initialFileSize={videoFileObject?.contentLength}
          />
        </div>
      </div>

      <div className="border rounded-lg border-zinc-800 p-6">
        <h3 className="text-lg font-semibold mb-4">Event Background Image</h3>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <FilePicker
            label="Background image for the event"
            name="backgroundImageUrl"
            accept={[FileMimeTypes.Png, FileMimeTypes.Jpeg, FileMimeTypes.Jpg]}
            withFilePreview
            placeholder="Add image file"
            tips={
              <p className="text-sm text-zinc-500">
                <span className="text-zinc-100">png, jpeg</span> or{' '}
                <span className="text-zinc-100">jpg</span> format. 10MB max
              </p>
            }
            maxFileSize={maxBackgroundImageSize}
            initialFileName={backgroundImageFileObject?.filename}
            initialFileSize={backgroundImageFileObject?.contentLength}
          />
        </div>
      </div>
    </div>
  );
};
